import React from "react";
import { connect, useDispatch } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createAction } from "../utility";
import * as LoginActions from "../../components/auth/store/auth.action";
import { removeAuth } from "../authService";

const Notification = (props) => {
  const dispatch = useDispatch();
  if (props.notification.type && props.notification.message) {
    const toastId = props.notification.status;
    if (!toast.isActive(toastId)) {
      toast[props.notification.type](props.notification.message, { toastId });
      setTimeout(props.removeNotification, 3000);
    }
  }

  const Logout = () => {
    dispatch(createAction("LOGOUT"));
    LoginActions.logout();
    removeAuth();
  };

  if (props.notification.status === 403) {
    Logout();
  }

  return (
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar
      closeOnClick
      pauseOnHover
    />
  );
};

const mapStateToProps = (state) => ({
  notification: state.common.notification,
});

const mapDispatchToProps = (dispatch) => ({
  removeNotification: () => dispatch(createAction("REMOVE_NOTIFICATION")),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
